import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=77b20bde&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b20bde')) {
      api.createRecord('77b20bde', component.options)
    } else {
      api.reload('77b20bde', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=77b20bde&", function () {
      api.rerender('77b20bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nu2Ico8SeGjR/JS/comp/ImgFallback.vue"
export default component.exports